import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/Button';
import { Input } from 'components/Input';

export const LoginForm = ({ title, pending, onSubmit }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    if (pending) {
      return;
    }

    onSubmit({
      username,
      password,
    });
  };

  const handleUsername = (value) => setUsername(value);
  const handlePassword = (value) => setPassword(value);

  return (
    <div className="login-block">
      <div className="login-block-title">{title}</div>

      <div className="login-block-container">
        <form>
          <Input type="text" title="Логин" value={username} onChange={handleUsername} required={true} />

          <Input type="password" title="Пароль" value={password} onChange={handlePassword} required={true} />
          <Button onClick={handleSubmit} className="btn-form" disabled={pending} loader={pending}>
            Войти
          </Button>
        </form>
      </div>
    </div>
  );
};

LoginForm.propTypes = {
  pending: PropTypes.bool,
  title: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
};

LoginForm.defaultProps = {
  pending: false,
  title: 'Авторизация',
};
